import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import { TOGGLE_ADMIN_READY, SAVE_SERVER_STATUS, SET_NOTIFY_STATUS} from "@/store/mutation-types";
import { dispatch } from "d3";

export default {
  actions: {
    setServerNotice: async ({ rootState, state, commit }, payload) => {
      if(state.adminReady || rootState.api.apiReady){
        commit(SAVE_SERVER_STATUS, payload);
      }
    },
    reportErrors: async (_, payload) => {
      return ApiRequest.explorePost("error_reporting", payload, GetHeaders.dataHeaders()).then(
        res => {
          if (!res) {
            return;
          }
          return res;
        }
      );
    },
    updateNotifyStatus: async({dispatch}, payload)=>{
      return ApiRequest.explorePost("update_notification_status",payload,GetHeaders.dataHeaders()).then(
        res=>{
          if (!res){
            return;
          }
          dispatch("setNotifyStatus",payload.status)
          return res;
        }
      );
    },
    getNotifyStatus: async({dispatch}) => {
      return ApiRequest.exploreGet("get_notify_status",GetHeaders.dataHeaders()).then(
        response=>{
          if (!response){
            return;
          }
          dispatch('setNotifyStatus',response.data.notify_status)
          return response.data
        }
      )
    },
    validateRealmSettings: async({dispatch}) =>{
      return ApiRequest.exploreGet("validate_realm_settings",GetHeaders.dataHeaders()).then(
        response=>{
          if (!response){
            return;
          }
          return response;
        }
      )
    },
    setNotifyStatus: async({commit}, payload)=>{
      commit(SET_NOTIFY_STATUS,payload)
    }
  },
  mutations: {
    [TOGGLE_ADMIN_READY](state, payload) {
      if (payload) {
        state.adminReady = payload.admin_ready;
      } else {
        state.adminReady = !state.adminReady;
      }
    },
    [SAVE_SERVER_STATUS](state, payload) {
      state.serverResponse = payload.msg;
      state.serverResponseCode = payload.code;
    },
    [SET_NOTIFY_STATUS](state,payload){
      state.notifyStatus = payload === "YES";
    }
  },
  state: {
    adminReady: false,
    serverResponse: null,
    serverResponseCode: null,
    notifyStatus: false
  }
};
